function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { FilterContext, UserContext } from "../index";
import Button from "react-bootstrap/Button";
import { Field, Form as FormikForm, Formik, FieldArray, getIn, useFormikContext } from "formik";
import * as Yup from "yup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import classNames from "classnames";
import ProjectAndTaskList from "./../ManualPages/ProjectAndTaskList";
import TimePicker from "rc-time-picker";
import Form from "react-bootstrap/Form";
import { PROJECTS_LISTING_QUERY, GET_TASK_TRACKER_QUERY, DELETE_TASK_TRACKER_MUTATION } from "./../ManualPages/query";
import { ADD_PROJECT_AND_TASK_TIMER_DETAILS_MUTATION, EDIT_PROJECT_AND_TASK_TIMER_DETAILS_MUTATION, ADD_PROJECT_AND_TASK_END_TIME_MUTATION, ADD_PROJECT_AND_TASK_END_TIME_FOR_AUTOMATIC_MUTATION } from "./query";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";
import DatePicker from "react-datepicker";
import { GoCalendar } from "react-icons/go";
import { arrayToStringOutput, stringToArrayOutput } from "./../SideMenu/Header";
import "./AddTask.css";
import moment from "moment-timezone";
import Table from "react-bootstrap/Table";
import { HiOutlineDotsVertical } from "react-icons/hi";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import { MdAdjust, MdDateRange } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import Loader from "./../Loader/Loader";
import { toast } from "react-toastify";
import { ProjectEnableSection } from "./../MyProjects/MyProjects";
import { MdDelete } from "react-icons/md";
import { GiConsoleController } from "react-icons/gi";
import { isNonNullType } from "graphql";
import { isRateLimited, rateLimitMessage } from "../utils";
var ManualModalSchema = Yup.object().shape({
  taskDescription: Yup.string().trim().max(300, "Maximum limit is 300 characters"),
  startTime: Yup.string().required("Required")
  // endTime: Yup.string().required("Required"),
});
var EditTaskSchema = Yup.object().shape({
  startTime: Yup.string().required("Required"),
  endTime: Yup.string().required("Required")
});
var TaskSchema = Yup.object().shape({
  startTime: Yup.string().required("Required"),
  endTime: Yup.string().required("Required")
});
var EditSchema = Yup.object().shape({
  taskDescription: Yup.string().max(300, "Too Long!"),
  editStartTime: Yup.string().required("Required"),
  editEndTime: Yup.string().required("Required")
});
var formats = "h:mm a";
var LIMIT = 15;
var offsets = 0;
var APP_LIMIT = 10;
var AddTask = function AddTask(props) {
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    startDate = _React$useContext2.startDate,
    endDate = _React$useContext2.endDate,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationBilling = _React$useContext2.organisationBilling,
    role = _React$useContext2.role,
    from = _React$useContext2.from,
    organisationStatus = _React$useContext2.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  // console.log({ automaticallyRecordTaskStartAndEndTime: organisationSettings?.automaticallyRecordTaskStartAndEndTime });

  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isNavClickProject = _React$useState2[0],
    setNavClickProject = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    projectError = _React$useState4[0],
    setProjectError = _React$useState4[1];
  var _React$useState5 = React.useState(new Date()),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    manualStartDate = _React$useState6[0],
    setManualStartDate = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isManualDatePickerOpen = _React$useState8[0],
    setIsManualDatePickerOpen = _React$useState8[1];
  var _React$useState9 = React.useState(undefined),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    modalValueEndTime = _React$useState10[0],
    setModalValueEndTime = _React$useState10[1];
  var _React$useState11 = React.useState(moment()),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    modalValueStartTime = _React$useState12[0],
    setModalValueStartTime = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    addedShow = _React$useState14[0],
    setAddedShow = _React$useState14[1];
  var _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    manualAddedShow = _React$useState16[0],
    setManualAddedShow = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isNavClick = _React$useState18[0],
    setNavClick = _React$useState18[1];
  var _React$useState19 = React.useState(""),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    modalStartTime = _React$useState20[0],
    setModalStartTime = _React$useState20[1];
  var _React$useState21 = React.useState(""),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    modalEndTime = _React$useState22[0],
    setModalEndTime = _React$useState22[1];
  var _React$useState23 = React.useState(0),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    notEndTaskCount = _React$useState24[0],
    setNotEndTask = _React$useState24[1];
  var _React$useState25 = React.useState([]),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    projectIds = _React$useState26[0],
    setProjectIds = _React$useState26[1];
  var _React$useState27 = React.useState([]),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    taskIds = _React$useState28[0],
    setTaskIds = _React$useState28[1];

  //loadmore
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    isAllLoaded = _React$useState30[0],
    setIsAllLoaded = _React$useState30[1];
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    isLoadingMore = _React$useState32[0],
    setIsLoadingMore = _React$useState32[1];
  var _React$useState33 = React.useState(false),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    isLoadMoreButton = _React$useState34[0],
    setIsLoadMoreButton = _React$useState34[1];
  var _React$useState35 = React.useState(null),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    loadingTaskId = _React$useState36[0],
    setLoadingTaskId = _React$useState36[1];
  var _React$useState37 = React.useState(null),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    EditViewerShow = _React$useState38[0],
    setEditViewerShow = _React$useState38[1];
  var _React$useState39 = React.useState(stringToArrayOutput("Free Plan Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    last14Days = _React$useState40[0],
    setLast14Days = _React$useState40[1];
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    if (role === "Member" && !organisationSettings.projectManagementFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  var _useQuery = useQuery(PROJECTS_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        from: props !== null && props !== void 0 && props.from ? "desktop" : null,
        role: role,
        page: "my-task"
      },
      skip: !organisationId || !teamId
    }),
    projectListing = _useQuery.data,
    projectListingError = _useQuery.error,
    projectListingLoading = _useQuery.loading,
    projectRefetch = _useQuery.refetch;
  React.useEffect(function () {
    projectRefetch === null || projectRefetch === void 0 ? void 0 : projectRefetch();
  }, [props.location.key]);
  var startOnChange = function startOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setModalValueStartTime(value);
      setModalStartTime(finalTime);
      setFieldValue("startTime", finalTime);
    } else {
      setModalStartTime("");
      setFieldValue("startTime", "");
    }
  };
  var endOnChange = function endOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setModalValueEndTime(value);
      setModalEndTime(finalTime);
      setFieldValue("endTime", finalTime);
    } else {
      setModalValueEndTime(undefined);
      setModalEndTime("");
      setFieldValue("endTime", "");
    }
  };
  var handleChange = function handleChange(e) {
    setIsManualDatePickerOpen(!isManualDatePickerOpen);
    setManualStartDate(e);
  };
  var _useMutation = useMutation(ADD_PROJECT_AND_TASK_END_TIME_FOR_AUTOMATIC_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addProjectAndTaskEndTimeForAutomatic = _useMutation2[0],
    autoAddProjectAndTaskEndTimeLoading = _useMutation2[1].loading;

  //   const handleStopTimeSubmit = async (values) => {

  //     const { endTime, organisationId, projectId, startTime, taskDate, taskId, taskTimeId, teamId, projectName,taskName } = values;

  //     setLoadingTaskId(taskTimeId);

  //     const dateTemp = moment(values.taskDate).format("DD/MM/YYYY");
  //     const statTimeTemp = moment(values.startTime).format("HH:mm");
  //     const startTimeValue = moment(dateTemp + " " + statTimeTemp, "DD/MM/YYYY HH:mm").valueOf();

  //     // console.log({ modalValueEndTime, modalValueStartTime });

  //     // endTime: null;
  //     // organisationId: "f2c9e240-4e71-11eb-9784-794f853f90e2";
  //     // projectId: "e5700170-5f09-11ec-a69b-b500538b8e10";
  //     // startTime: 1768387200000;
  //     // taskDate: 1768387252000;
  //     // taskId: "d3052524-5db6-4519-80df-735468b6d42f";
  //     // taskTimeId: "89a2e480-f135-11f0-82ca-0d7804fab56c";
  //     // teamId: "all";

  //     const variables = {
  //       projectId,
  //       taskId,
  //       organisationId,
  //       taskTimeId,
  //       timezone: organisationSettings?.organisationTimezone,
  //       startTime: statTimeTemp,
  //       endTime: null,
  //       taskDate: moment(taskDate).valueOf(),
  //       newTaskDate: null,
  //     };

  //     //console.log({ variables });

  //     // try {
  //     //   const response = await addProjectAndTaskEndTime({
  //     //     variables,
  //     //     awaitRefetchQueries: true,
  //     //     refetchQueries: [
  //     //       {
  //     //         query: GET_TASK_TRACKER_QUERY,
  //     //         variables: {
  //     //           organisationId,
  //     //           teamId,
  //     //           userId: [user.userId],
  //     //           projectId: null,
  //     //           taskId: null,
  //     //           limit: LIMIT,
  //     //           offset: 0,
  //     //           freePlanStartDate: organisationBilling?.planName == "free" ? (last14Days ? last14Days[0] : null) : null,
  //     //           freePlanEndDate: organisationBilling?.planName == "free" ? (last14Days ? last14Days[1] : null) : null,
  //     //           role,
  //     //           entryStatus : "",
  //     //         },
  //     //       },
  //     //     ],
  //     //   });

  //     //   if (response && response.data && response.data.addProjectAndTaskEndTime == true) {
  //     //     toast.success("End time updated successfully!");
  //     //   } else {
  //     //     toast.error("Error Occured, try again!");
  //     //   }

  //     // setLoadingTaskId(null);

  //     // } catch (error) {
  //     //   setProjectError(true);
  //     // }

  //     try{
  //     const response = await addProjectAndTaskEndTime({
  //         variables,
  //         update(cache, { data }) {
  //           if (!data?.addProjectAndTaskEndTime) return;

  //         const taskDateMoment = variables.taskDate ? moment(variables.taskDate) : moment().tz(timezone).valueOf() ;

  //   // const startDateTime = variables.startTime ? moment(
  //   //   `${taskDateMoment.format("DD/MM/YYYY")} ${variables.startTime}`,
  //   //   "DD/MM/YYYY HH:mm"
  //   // ).toISOString() : moment.tz(timezone).valueOf();

  //   const endDateTime = 
  //     variables.endTime
  //       ? moment(
  //           `${taskDateMoment.format("DD/MM/YYYY")} ${variables.endTime}`,
  //           "DD/MM/YYYY HH:mm"
  //         ).toISOString()
  //       : moment.tz(organisationSettings?.organisationTimezone).valueOf();

  //   // const totalTimeInSec =
  //   //   endDateTime
  //   //     ? Math.round(
  //   //         moment
  //   //           .duration(moment(endDateTime).diff(moment(startDateTime)))
  //   //           .asSeconds()
  //   //       )
  //   //     : 0;

  //       const formatTotalTime = (seconds) => {
  //   if (!seconds || seconds <= 0) return "00h 00m";

  //   const hours = Math.floor(seconds / 3600);
  //   const minutes = Math.floor((seconds % 3600) / 60);

  //   return `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m`;
  // };

  //        const totalTimeFormatted = formatTotalTime(totalTimeInSec);

  //         cache.modify({
  //           fields: {
  //             getTaskTrackerDetails(existingData = {}, { readField }) {
  //               if (!existingData?.taskTrackerDatas) return existingData;

  //               const updatedList = existingData.taskTrackerDatas.map((task) => {
  //                 if (task.taskTimeId !== variables.taskTimeId) return task;

  //                 // 👉 IMPORTANT FIX: get ACTUAL startTime from cache
  //                 const existingStartTime = readField("startTime", task);

  //                 const totalTimeInSec = Math.round(
  //                   moment
  //                     .duration(
  //                       moment(endDateTime).diff(moment(existingStartTime))
  //                     )
  //                     .asSeconds()
  //                 );

  //                 const formatTotalTime = (seconds) => {
  //                   if (!seconds || seconds <= 0) return "00h 00m";
  //                   const hours = Math.floor(seconds / 3600);
  //                   const minutes = Math.floor((seconds % 3600) / 60);
  //                   return `${String(hours).padStart(2, "0")}h ${String(
  //                     minutes
  //                   ).padStart(2, "0")}m`;
  //                 };

  //                 return {
  //                   ...task,
  //                   endTime: endDateTime,
  //                   totalTimeInSec,
  //                   totalTime: formatTotalTime(totalTimeInSec),
  //                 };
  //               });

  //               return {
  //                 ...existingData,
  //                 taskTrackerDatas: updatedList,
  //               };
  //             },
  //           },
  //         });
  //       },
  //     });

  //       if (response && response.data && response.data.addProjectAndTaskEndTime !== "") {
  //         toast.success("End time updated successfully!");
  //       } else {
  //         toast.error("Error Occured, try again!");
  //       }

  //     setLoadingTaskId(null);

  //   } catch (error) {
  //     console.error(error);
  //     setProjectError(true);
  //   } finally {
  //     setLoadingTaskId(null);
  //   }
  // };

  var handleStopTimeSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var organisationId, projectId, startTime, taskDate, taskId, taskTimeId, variables, _response$data, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            organisationId = values.organisationId, projectId = values.projectId, startTime = values.startTime, taskDate = values.taskDate, taskId = values.taskId, taskTimeId = values.taskTimeId;
            setLoadingTaskId(taskTimeId);
            variables = {
              projectId: projectId,
              taskId: taskId,
              organisationId: organisationId,
              taskTimeId: taskTimeId,
              timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              endTime: null,
              // ← unchanged
              newTaskDate: null
            };
            _context.prev = 3;
            _context.next = 6;
            return addProjectAndTaskEndTimeForAutomatic({
              variables: variables,
              update: function update(cache, _ref2) {
                var data = _ref2.data;
                var updated = data === null || data === void 0 ? void 0 : data.addProjectAndTaskEndTimeForAutomatic;
                if (!updated) return;

                // const endDateTime = moment
                //   .tz(variables.timezone || moment.tz.guess())
                //   .toISOString();

                cache.modify({
                  fields: {
                    getTaskTrackerDetails: function getTaskTrackerDetails() {
                      var existingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
                        readField = _ref3.readField;
                      if (!(existingData !== null && existingData !== void 0 && existingData.taskTrackerDatas)) return existingData;
                      var updatedList = existingData.taskTrackerDatas.map(function (task) {
                        if (task.taskTimeId !== updated.taskTimeId) return task;
                        return _objectSpread(_objectSpread({}, task), {}, {
                          endTime: updated.endTime,
                          totalTimeInSec: updated.totalTimeInSec,
                          totalTime: updated.totalTime
                        });
                      });
                      return _objectSpread(_objectSpread({}, existingData), {}, {
                        taskTrackerDatas: updatedList
                      });
                    }
                  }
                });
              }
            });
          case 6:
            response = _context.sent;
            if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.addProjectAndTaskEndTimeForAutomatic) {
              setNotEndTask(function (prev) {
                return prev > 0 ? prev - 1 : 0;
              });
              toast.success("End time updated successfully!");
            } else {
              toast.error("Error Occured, try again!");
            }
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
            setProjectError(true);
          case 14:
            _context.prev = 14;
            setLoadingTaskId(null);
            return _context.finish(14);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10, 14, 17]]);
    }));
    return function handleStopTimeSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", null, !organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement(ProjectEnableSection, {
    user: user,
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    filterId: null,
    role: role,
    pageName: "my-task",
    isTaskViewCheck: null,
    teamId: teamId,
    projectIds: projectIds,
    taskIds: taskIds,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    last14Days: last14Days,
    from: null,
    propsUserId: null,
    userIds: null,
    userActive: null,
    projectActive: null,
    taskActive: null,
    startDate: null,
    endDate: null,
    projectId: null,
    userUrl: null
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddProjectTaskDetails, {
    ManualModalSchema: ManualModalSchema,
    addedShow: addedShow,
    isNavClickProject: isNavClickProject,
    isNavClick: isNavClick,
    setNavClick: setNavClick,
    setAddedShow: setAddedShow,
    projectListing: projectListing,
    setProjectError: setProjectError,
    modalValueStartTime: modalValueStartTime,
    startOnChange: startOnChange,
    formats: formats,
    modalValueEndTime: modalValueEndTime,
    endOnChange: endOnChange,
    manualStartDate: manualStartDate,
    isManualDatePickerOpen: isManualDatePickerOpen,
    handleChange: handleChange,
    organisationSettings: organisationSettings,
    user: user,
    projectIds: projectIds,
    taskIds: taskIds,
    organisationId: organisationId,
    teamId: teamId,
    setManualAddedShow: setManualAddedShow,
    setManualStartDate: setManualStartDate,
    setModalValueEndTime: setModalValueEndTime,
    setModalValueStartTime: setModalValueStartTime,
    projectError: projectError,
    setIsAllLoaded: setIsAllLoaded,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    last14Days: last14Days,
    role: role,
    notEndTaskCount: notEndTaskCount,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    setNotEndTask: setNotEndTask
  }), /*#__PURE__*/React.createElement(ProjectTaskList, {
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    user: user,
    location: props.location,
    teamId: teamId,
    role: role,
    from: from,
    startDate: startDate,
    endDate: endDate,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    projectListing: projectListing,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    setIsLoadMoreButton: setIsLoadMoreButton,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    last14Days: last14Days,
    allowEmployeesToEditTaskTimes: organisationSettings.allowEmployeesToEditTaskTimes,
    setNotEndTask: setNotEndTask,
    notEndTaskCount: notEndTaskCount,
    handleStopTimeSubmit: handleStopTimeSubmit,
    autoAddProjectAndTaskEndTimeLoading: autoAddProjectAndTaskEndTimeLoading,
    loadingTaskId: loadingTaskId
  })));
};

// ✅ time formatter helper
var formatTotalTime = function formatTotalTime(seconds) {
  if (!seconds || seconds <= 0) return "00h 00m";
  var hrs = Math.floor(seconds / 3600);
  var mins = Math.floor(seconds % 3600 / 60);
  return "".concat(String(hrs).padStart(2, "0"), "h ").concat(String(mins).padStart(2, "0"), "m");
};
var AddProjectTaskDetails = function AddProjectTaskDetails(props) {
  var ManualModalSchema = props.ManualModalSchema,
    addedShow = props.addedShow,
    isNavClickProject = props.isNavClickProject,
    isNavClick = props.isNavClick,
    setNavClick = props.setNavClick,
    setAddedShow = props.setAddedShow,
    projectListing = props.projectListing,
    setProjectError = props.setProjectError,
    modalValueStartTime = props.modalValueStartTime,
    startOnChange = props.startOnChange,
    formats = props.formats,
    modalValueEndTime = props.modalValueEndTime,
    endOnChange = props.endOnChange,
    manualStartDate = props.manualStartDate,
    isManualDatePickerOpen = props.isManualDatePickerOpen,
    handleChange = props.handleChange,
    organisationSettings = props.organisationSettings,
    projectIds = props.projectIds,
    taskIds = props.taskIds,
    organisationId = props.organisationId,
    teamId = props.teamId,
    user = props.user,
    setManualAddedShow = props.setManualAddedShow,
    setManualStartDate = props.setManualStartDate,
    setModalValueEndTime = props.setModalValueEndTime,
    setModalValueStartTime = props.setModalValueStartTime,
    projectError = props.projectError,
    setIsAllLoaded = props.setIsAllLoaded,
    planName = props.planName,
    last14Days = props.last14Days,
    role = props.role,
    notEndTaskCount = props.notEndTaskCount,
    timezone = props.timezone,
    setNotEndTask = props.setNotEndTask;
  var _React$useState41 = React.useState(null),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    startTimeTemp = _React$useState42[0],
    setStartTimeTemp = _React$useState42[1];
  var _React$useState43 = React.useState(null),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    endTimeTemp = _React$useState44[0],
    setEndTimeTemp = _React$useState44[1];
  var _React$useState45 = React.useState(false),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    endTimeErr = _React$useState46[0],
    setEndTimeErr = _React$useState46[1];

  // Server-side rejection for the timer form, shown under the Add Task button.
  var _React$useState47 = React.useState(null),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    timerSubmitError = _React$useState48[0],
    setTimerSubmitError = _React$useState48[1];
  var _useMutation3 = useMutation(ADD_PROJECT_AND_TASK_TIMER_DETAILS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addProjectAndTaskTimerDetails = _useMutation4[0],
    addProjectAndTaskTimerDetailsLoading = _useMutation4[1].loading;
  React.useEffect(function () {
    if (modalValueStartTime && modalValueEndTime) {
      if (modalValueEndTime < modalValueStartTime) {
        setEndTimeErr(true);
      } else {
        setEndTimeErr(false);
      }
    }
  }, [modalValueEndTime, modalValueStartTime]);
  var handleTimerSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, _ref4) {
      var resetForm, taskDescription, startTime, endTime, variables, _response$data2, response, _response$errors, _response$errors$, _err$graphQLErrors, _err$graphQLErrors$;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            resetForm = _ref4.resetForm;
            taskDescription = values.taskDescription, startTime = values.startTime, endTime = values.endTime;
            setTimerSubmitError(null);
            if (!(addedShow == null)) {
              _context2.next = 6;
              break;
            }
            setProjectError(true);
            return _context2.abrupt("return");
          case 6:
            if (!(modalValueEndTime < modalValueStartTime)) {
              _context2.next = 9;
              break;
            }
            setEndTimeErr(true);
            return _context2.abrupt("return");
          case 9:
            variables = {
              projectId: addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId,
              taskId: (addedShow === null || addedShow === void 0 ? void 0 : addedShow.taskId) || null,
              taskDescription: taskDescription,
              organisationId: organisationId,
              teamId: teamId,
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              startTime: !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? startTime : null,
              endTime: !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? endTime : endTime ? endTime : null,
              taskDate: !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? moment(manualStartDate).valueOf() : null,
              role: role
            }; // try {
            //   const response = await addProjectAndTaskTimerDetails({
            //     variables,
            //     awaitRefetchQueries: true,
            //     refetchQueries: [
            //       {
            //         query: GET_TASK_TRACKER_QUERY,
            //         variables: {
            //           organisationId,
            //           teamId,
            //           userId: [user.userId],
            //           projectId: projectIds.length ? projectIds : null,
            //           taskId: taskIds.length ? taskIds : null,
            //           limit: LIMIT,
            //           offset: 0,
            //           freePlanStartDate: planName == "free" ? (last14Days ? last14Days[0] : null) : null,
            //           freePlanEndDate: planName == "free" ? (last14Days ? last14Days[1] : null) : null,
            //           role,
            //           entryStatus : "",
            //         },
            //       },
            //     ],
            //   });
            //   if (response && response.data && response.data.addProjectAndTaskTimerDetails == true) {
            //     toast.success("Task added successfully!");
            //     setManualAddedShow(null);
            //     setAddedShow(null);
            //     setManualStartDate(undefined);
            //     setModalValueEndTime(undefined);
            //     setModalValueStartTime(moment());
            //     setStartTimeTemp(null);
            //     setEndTimeTemp(null);
            //     setIsAllLoaded(false);
            //     offsets = 0;
            //     resetForm({});
            //   } else {
            //     toast.error("Error Occured, try again!");
            //   }
            // } catch (error) {
            //   setProjectError(true);
            // }
            _context2.prev = 10;
            _context2.next = 13;
            return addProjectAndTaskTimerDetails({
              variables: variables,
              update: function update(cache, _ref6) {
                var data = _ref6.data;
                var serverData = data === null || data === void 0 ? void 0 : data.addProjectAndTaskTimerDetails;
                if (!serverData) return;

                //console.log({ serverData });

                // ✅ trust backend completely
                var startDateTime = serverData.startTime || null;
                var endDateTime = serverData.endTime || null;
                var taskDateValue = serverData.taskDate || null;
                var totalTimeFormatted = formatTotalTime(serverData.totalTimeInSec);
                var newTaskEntry = {
                  __typename: "WorkHistoryTaskTrackerDetailData",
                  taskTimeId: serverData.taskTimeId || null,
                  projectName: addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectName,
                  taskName: (addedShow === null || addedShow === void 0 ? void 0 : addedShow.taskName) || null,
                  projectId: addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId,
                  taskId: addedShow === null || addedShow === void 0 ? void 0 : addedShow.taskId,
                  taskDescription: variables.taskDescription,
                  // ✅ FROM BACKEND
                  startTime: startDateTime,
                  endTime: endDateTime,
                  taskDate: taskDateValue,
                  createdAt: new Date().toISOString(),
                  totalTimeInSec: serverData.totalTimeInSec,
                  totalTime: totalTimeFormatted,
                  user: {
                    __typename: "User",
                    userId: user.userId,
                    displayName: user.displayName || "",
                    profileUrl: user.profileUrl || null
                  }
                };

                //console.log({ newTaskEntry, variables });

                cache.modify({
                  fields: {
                    getTaskTrackerDetails: function getTaskTrackerDetails() {
                      var existingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      if (!(existingData !== null && existingData !== void 0 && existingData.taskTrackerDatas)) return existingData;
                      var newList = [].concat(_toConsumableArray(existingData.taskTrackerDatas), [newTaskEntry]);

                      // ✅🔥 FINAL SAFE SORT (NO CRASH)
                      newList.sort(function (a, b) {
                        // safe taskDate compare
                        var dateA = typeof a.taskDate === "number" ? a.taskDate : moment(a.taskDate).valueOf();
                        var dateB = typeof b.taskDate === "number" ? b.taskDate : moment(b.taskDate).valueOf();
                        var dateDiff = dateB - dateA;
                        if (dateDiff !== 0) return dateDiff;

                        // safe startTime compare (null safe)
                        var startA = a.startTime ? moment(a.startTime).valueOf() : 0;
                        var startB = b.startTime ? moment(b.startTime).valueOf() : 0;
                        return startB - startA;
                      });
                      return _objectSpread(_objectSpread({}, existingData), {}, {
                        taskTrackerDatas: newList
                      });
                    }
                  }
                });
              }
            });
          case 13:
            response = _context2.sent;
            // ✅ correct success check (object response)
            if (response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.addProjectAndTaskTimerDetails) {
              toast.success("Task added successfully!");
              setTimerSubmitError(null);
              setNotEndTask(function (prev) {
                return prev + 1;
              });
              setManualAddedShow(null);
              setAddedShow(null);
              setManualStartDate(undefined);
              setModalValueEndTime(undefined);
              setModalValueStartTime(moment());
              setStartTimeTemp(null);
              setEndTimeTemp(null);
              resetForm({});
            } else {
              setTimerSubmitError((response === null || response === void 0 ? void 0 : (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : (_response$errors$ = _response$errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.message) || "Error Occured, try again!");
            }
            _context2.next = 21;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](10);
            // ✅ keep this during testing
            console.error("TIMER ERROR:", _context2.t0);

            // Show the server's own message (e.g. "Maximum limit of 10 task timers per
            // day has been reached.") under the button. Network failures have no
            // graphQLErrors, so those keep the generic text.
            setTimerSubmitError((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_err$graphQLErrors = _context2.t0.graphQLErrors) === null || _err$graphQLErrors === void 0 ? void 0 : (_err$graphQLErrors$ = _err$graphQLErrors[0]) === null || _err$graphQLErrors$ === void 0 ? void 0 : _err$graphQLErrors$.message) || "Error Occured, try again!");
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[10, 17]]);
    }));
    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }(), [addProjectAndTaskTimerDetails, addProjectAndTaskTimerDetailsLoading, addedShow, manualStartDate, modalValueEndTime, modalValueStartTime]);
  function generateOptions(length, excludedOptions) {
    var arr = [];
    for (var value = 0; value < length; value++) {
      if (excludedOptions.indexOf(value) > 0) {
        arr.push(value);
      }
    }
    return arr;
  }
  function check12PmStatus(value, startTimeHour, endTimeHour, startTimeData, endTimeHourData) {
    if (value == 24 && startTimeHour <= 12 && endTimeHour >= 12 && (startTimeData == "pm" || endTimeHourData == "pm")) {
      return false;
    }
    return true;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-card-root-add-section"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      taskDescription: "",
      startTime: moment().tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("HH:mm"),
      endTime: ""
    }
    // enableReinitialize={true}
    // validateOnChange={false}
    ,
    validateOnBlur: false,
    validationSchema: ManualModalSchema,
    onSubmit: handleTimerSubmit
  }, function (_ref7) {
    var setFieldValue = _ref7.setFieldValue,
      isSubmitting = _ref7.isSubmitting,
      errors = _ref7.errors,
      touched = _ref7.touched,
      values = _ref7.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? "project-task-time-mapping-formik-add-form" : "project-task-time-mapping-formik-add-form-automatic"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-formik-add-form-select-project-task-div"
    }, /*#__PURE__*/React.createElement(Form.Label, {
      className: "task-tracker-edit-label project-task-time-mapping-formik-add-form-label"
    }, "Select Project & Task"), addedShow ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-added",
        className: "project-tooltip-start"
      }, addedShow.projectName, " ", addedShow.taskName ? " - ".concat(addedShow.taskName) : "")
    }, /*#__PURE__*/React.createElement(Dropdown, {
      open: isNavClickProject,
      className: classNames("project-task-time-mapping-formik-add-project-button", {
        "project-task-time-mapping-formik-add-project-button-error": projectError
      })
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics"
    }, addedShow ? "".concat(addedShow.projectName, " ").concat(addedShow.taskName ? " - ".concat(addedShow.taskName) : "") : "+ Select Project & Task"), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
      isNavClick: isNavClick,
      setNavClick: setNavClick,
      addedShow: addedShow,
      setAddedShow: setAddedShow,
      projectListing: projectListing,
      setProjectError: setProjectError,
      from: props.from ? "desktop" : null,
      type: "addTask",
      editAddedShow: null,
      setEditAddedShow: null
    })))) : /*#__PURE__*/React.createElement(Dropdown, {
      open: isNavClickProject,
      className: classNames("project-task-time-mapping-formik-add-project-button", {
        "project-task-time-mapping-formik-add-project-button-error": projectError
      })
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics"
    }, addedShow ? "".concat(addedShow.projectName, " ").concat(addedShow.taskName ? " - ".concat(addedShow.taskName) : "") : "+ Select Project & Task"), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
      isNavClick: isNavClick,
      setNavClick: setNavClick,
      addedShow: addedShow,
      setAddedShow: setAddedShow,
      projectListing: projectListing,
      setProjectError: setProjectError,
      from: props.from ? "desktop" : null,
      type: "addTask",
      editAddedShow: null,
      setEditAddedShow: null
    })))), /*#__PURE__*/React.createElement(Field, {
      name: "taskDescription"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, {
        className: !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? "project-task-time-mapping-formik-add-form-text-box" : "project-task-time-mapping-formik-add-form-text-box-automatic project-task-time-mapping-formik-add-form-text-box-automatic-width"
      }, /*#__PURE__*/React.createElement(Form.Label, {
        className: "task-tracker-edit-label project-task-time-mapping-formik-add-form-label"
      }, "Description"), /*#__PURE__*/React.createElement(Field, _extends({
        as: Form.Control,
        name: "taskDescription",
        type: "text",
        placeholder: "Type the description"
      }, field)), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null);
    }), !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "startTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "task-tracker-edit-label project-task-time-mapping-formik-add-form-label"
      }, "Start Time"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "startTime",
        value: modalValueStartTime,
        className: meta.error && meta.touched ? "project-task-time-mapping-formik-add-form-start-time-error" : "project-task-time-mapping-formik-add-form-start-time",
        onChange: function onChange(e) {
          startOnChange(e, setFieldValue);
          setStartTimeTemp(e);
        },
        placeholder: "Start Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null
        // inputReadOnly
        // disabledHours={disabledStartTimeHours}
        // disabledMinutes={disabledStartTimeMinutes}
      })));
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "endTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      //console.log("err", meta.error);

      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "task-tracker-edit-label project-task-time-mapping-formik-add-form-label"
      }, "End Time (Optional)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "endTime",
        value: modalValueEndTime,
        className: meta.error && meta.touched ? "project-task-time-mapping-formik-add-form-end-time-error" : "project-task-time-mapping-formik-add-form-end-time",
        onChange: function onChange(e) {
          endOnChange(e, setFieldValue);
          setEndTimeTemp(e);
        },
        placeholder: "End Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined
        // clearIcon={null}
        // inputReadOnly
        // disabledHours={disabledHours}
        // disabledMinutes={disabledMinutes}
      }), /*#__PURE__*/React.createElement("div", {
        className: "manual-home-project-formik-add-form-edit-end-time"
      }, modalValueEndTime < modalValueStartTime ? "End time should be greater than the start time" : "")));
    })), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-edit-task-date project-task-time-mapping-edit-time-div"
    }, /*#__PURE__*/React.createElement("label", {
      className: "task-tracker-edit-label project-task-time-mapping-formik-add-form-label"
    }, "Date"), " ", /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-calender-div manual-page-content-wrapper-filter-date-date-section"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      trigger: "click",
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Popover, {
        className: "project-task-time-mapping-wrapper-menu-filter-overlay-trigger"
      }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(DatePicker, {
        selected: manualStartDate,
        onChange: handleChange,
        open: isManualDatePickerOpen,
        inline: true,
        maxDate: new Date()
      })))
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-calender-icon-div"
    }, /*#__PURE__*/React.createElement(GoCalendar, {
      className: "project-task-time-mapping-section-calender-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "project-task-time-mapping-section-calender-text"
    }, arrayToStringOutput([manualStartDate, manualStartDate], organisationSettings.organisationTimezone))))))) : null, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-project-formik-add-button-div"
    }, !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      className: "project-task-time-mapping-project-formik-add-button",
      type: "submit"
      //disabled={notEndTaskCount > 0 || addProjectAndTaskTimerDetailsLoading ? true : false}
      ,
      disabled: addProjectAndTaskTimerDetailsLoading ? true : false
    }, addProjectAndTaskTimerDetailsLoading ? "Loading..." : !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? "Add Task" : "Start Task") : organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.restrictNewTaskWhenPending ? notEndTaskCount <= 0 ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Click to start the task. The current time will be recorded as the start time.")
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      className: "project-task-time-mapping-project-formik-add-button",
      type: "submit"
      //disabled={notEndTaskCount > 0 || addProjectAndTaskTimerDetailsLoading ? true : false}
      ,
      disabled: addProjectAndTaskTimerDetailsLoading ? true : false
    }, addProjectAndTaskTimerDetailsLoading ? "Loading..." : !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? "Add Task" : "Start Task")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "currently-working",
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, " ", "You already have a task in progress. Stop it to start a new task.")
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-project-formik-add-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      className: "add-task-page-disable-button"
    }, "Start Task"))) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Click to start the task. The current time will be recorded as the start time.")
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      className: "project-task-time-mapping-project-formik-add-button",
      type: "submit"
      //disabled={notEndTaskCount > 0 || addProjectAndTaskTimerDetailsLoading ? true : false}
      ,
      disabled: addProjectAndTaskTimerDetailsLoading ? true : false
    }, addProjectAndTaskTimerDetailsLoading ? "Loading..." : !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? "Add Task" : "Start Task")))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, timerSubmitError ? /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-add-task-submit-error"
    }, timerSubmitError) : null)));
  }));
};
var ProjectTaskList = function ProjectTaskList(props) {
  var _taskTrackerData$getT4, _taskTrackerData$getT5, _taskTrackerData$getT6, _taskTrackerData$getT7, _taskTrackerData$getT8, _taskTrackerData$getT9, _taskTrackerData$getT10, _taskTrackerData$getT13, _taskTrackerData$getT14;
  var organisationId = props.organisationId,
    organisationSettings = props.organisationSettings,
    user = props.user,
    location = props.location,
    teamId = props.teamId,
    role = props.role,
    from = props.from,
    startDate = props.startDate,
    endDate = props.endDate,
    timezone = props.timezone,
    projectListing = props.projectListing,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    setIsLoadMoreButton = props.setIsLoadMoreButton,
    planName = props.planName,
    last14Days = props.last14Days,
    allowEmployeesToEditTaskTimes = props.allowEmployeesToEditTaskTimes,
    setNotEndTask = props.setNotEndTask,
    notEndTaskCount = props.notEndTaskCount,
    handleStopTimeSubmit = props.handleStopTimeSubmit,
    autoAddProjectAndTaskEndTimeLoading = props.autoAddProjectAndTaskEndTimeLoading,
    loadingTaskId = props.loadingTaskId;

  // //loadmore
  // const [isAllLoaded, setIsAllLoaded] = React.useState(false);
  // const [isLoadingMore, setIsLoadingMore] = React.useState(false);
  // const [isLoadMoreButton, setIsLoadMoreButton] = React.useState(false);

  var _React$useState49 = React.useState([]),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    userIds = _React$useState50[0],
    setUserIds = _React$useState50[1];
  var _React$useState51 = React.useState([]),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    projectIds = _React$useState52[0],
    setProjectIds = _React$useState52[1];
  var _React$useState53 = React.useState([]),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    taskIds = _React$useState54[0],
    setTaskIds = _React$useState54[1];
  var _React$useState55 = React.useState(null),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    showPlayButton = _React$useState56[0],
    setShowPlayButton = _React$useState56[1];
  var _React$useState57 = React.useState(false),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    desktopLoader = _React$useState58[0],
    setdesktopLoader = _React$useState58[1];

  // const [showTaskModal, setShowTaskModal] = React.useState(null);
  var _React$useState59 = React.useState(null),
    _React$useState60 = _slicedToArray(_React$useState59, 2),
    EditViewerShow = _React$useState60[0],
    setEditViewerShow = _React$useState60[1];
  // userId: props?.from ? [props?.userId] : userIds.length ? userIds : null,

  var _React$useState61 = React.useState("task-details"),
    _React$useState62 = _slicedToArray(_React$useState61, 2),
    taskDetailsActiveTab = _React$useState62[0],
    setTaskDetailsActiveTab = _React$useState62[1];
  var _React$useState63 = React.useState(null),
    _React$useState64 = _slicedToArray(_React$useState63, 2),
    showDeleteModal = _React$useState64[0],
    setShowDeleteModal = _React$useState64[1];
  var _React$useState65 = React.useState(false),
    _React$useState66 = _slicedToArray(_React$useState65, 2),
    isTaskDeleted = _React$useState66[0],
    setIsTaskDeleted = _React$useState66[1];
  var _React$useState67 = React.useState(null),
    _React$useState68 = _slicedToArray(_React$useState67, 2),
    showEndTimeModal = _React$useState68[0],
    setShowEndTimeModal = _React$useState68[1];
  var _React$useState69 = React.useState(null),
    _React$useState70 = _slicedToArray(_React$useState69, 2),
    showStopTaskWarningModal = _React$useState70[0],
    setShowStopTaskWarningModal = _React$useState70[1];
  var _useQuery2 = useQuery(GET_TASK_TRACKER_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: [user.userId],
        projectId: projectIds.length ? projectIds : null,
        taskId: taskIds.length ? taskIds : null,
        limit: LIMIT,
        offset: 0,
        freePlanStartDate: planName == "free" ? last14Days ? last14Days[0] : null : null,
        freePlanEndDate: planName == "free" ? last14Days ? last14Days[1] : null : null,
        role: role,
        // freePlanStartDate: null,
        // freePlanEndDate: null,
        entryStatus: ""
      },
      skip: !teamId || !organisationId,
      //fetchPolicy: "network-only",
      //fetchPolicy: "cache-first"
      //nextFetchPolicy: "cache-and-network",
      fetchPolicy: "cache-first",
      // ← KEY CHANGE
      nextFetchPolicy: "cache-only" // ← prevents future refetch
    }),
    taskTrackerData = _useQuery2.data,
    taskTrackerError = _useQuery2.error,
    taskTrackerLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    taskRefetch = _useQuery2.refetch;
  React.useEffect(function () {
    taskRefetch === null || taskRefetch === void 0 ? void 0 : taskRefetch();
  }, [location.key]);
  React.useEffect(function () {
    var _taskTrackerData$getT;
    if (taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT !== void 0 && _taskTrackerData$getT.endNowButton) {
      var _taskTrackerData$getT2, _taskTrackerData$getT3;
      setNotEndTask(taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT2 = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT2 !== void 0 && _taskTrackerData$getT2.endNowButton ? taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT3 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT3 === void 0 ? void 0 : _taskTrackerData$getT3.endNowButton.length : 0);
    }
  }, [taskTrackerData]);
  var handleClose = function handleClose() {
    setEditViewerShow(null);
  };
  var handleShow = function handleShow(value) {
    setEditViewerShow(value);
  };
  var handleDeleteShow = function handleDeleteShow(list) {
    setShowDeleteModal(list);
  };
  var handleDeleteClose = function handleDeleteClose() {
    setShowDeleteModal(null);
  };
  var handleStopTaskWarningClose = function handleStopTaskWarningClose() {
    setShowStopTaskWarningModal(null);
  };
  var handleEndTimeShow = function handleEndTimeShow(list) {
    setShowEndTimeModal(list);
  };
  var handleEndTimeClose = function handleEndTimeClose() {
    setShowEndTimeModal(null);
  };
  var handleLoadMore = function handleLoadMore() {
    if (taskTrackerLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref8) {
        var _fetchMoreResult$getT, _fetchMoreResult$getT2, _fetchMoreResult$getT3, _fetchMoreResult$getT4;
        var fetchMoreResult = _ref8.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getT = fetchMoreResult.getTaskTrackerDetails) === null || _fetchMoreResult$getT === void 0 ? void 0 : (_fetchMoreResult$getT2 = _fetchMoreResult$getT.taskTrackerDatas) === null || _fetchMoreResult$getT2 === void 0 ? void 0 : _fetchMoreResult$getT2.length) === 0 && ((_fetchMoreResult$getT3 = fetchMoreResult.getTaskTrackerDetails) === null || _fetchMoreResult$getT3 === void 0 ? void 0 : _fetchMoreResult$getT3.taskTrackerDatas.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        var NewFilterData = [];
        (_fetchMoreResult$getT4 = fetchMoreResult.getTaskTrackerDetails) === null || _fetchMoreResult$getT4 === void 0 ? void 0 : _fetchMoreResult$getT4.taskTrackerDatas.forEach(function (newTask) {
          var found = prev.getTaskTrackerDetails.taskTrackerDatas.find(function (item) {
            return item.taskTimeId === newTask.taskTimeId;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newTask);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          getTaskTrackerDetails: _objectSpread(_objectSpread({}, prev.getTaskTrackerDetails), {}, {
            taskTrackerDatas: [].concat(_toConsumableArray(prev.getTaskTrackerDetails.taskTrackerDatas), NewFilterData)
          })
        });
      }
    });
  };
  if (taskTrackerLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (taskTrackerError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, please refresh the page.");
  }
  if (!taskTrackerData) {
    return null;
  }
  if ((taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT4 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT4 === void 0 ? void 0 : (_taskTrackerData$getT5 = _taskTrackerData$getT4.taskTrackerDatas) === null || _taskTrackerData$getT5 === void 0 ? void 0 : _taskTrackerData$getT5.length) !== 0 && (taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT6 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT6 === void 0 ? void 0 : (_taskTrackerData$getT7 = _taskTrackerData$getT6.taskTrackerDatas) === null || _taskTrackerData$getT7 === void 0 ? void 0 : _taskTrackerData$getT7.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "project-task-time-mapping-root-list-section-body"
  }, taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT8 = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT8 !== void 0 && (_taskTrackerData$getT9 = _taskTrackerData$getT8.taskTrackerDatas) !== null && _taskTrackerData$getT9 !== void 0 && _taskTrackerData$getT9.length ? /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "project-task-time-mapping-table"
  }, /*#__PURE__*/React.createElement("tbody", {
    className: "project-task-time-mapping-table-body"
  }, taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT10 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT10 === void 0 ? void 0 : _taskTrackerData$getT10.taskTrackerDatas.map(function (list, index) {
    var _taskTrackerData$getT11, _taskTrackerData$getT12;
    var startTime = list.startTime,
      endTime = list.endTime,
      totalTime = list.totalTime,
      taskDescription = list.taskDescription,
      taskName = list.taskName,
      projectName = list.projectName,
      user = list.user,
      taskDate = list.taskDate,
      trackStatus = list.trackStatus,
      projectId = list.projectId,
      taskId = list.taskId,
      taskTimeId = list.taskTimeId,
      deletedStatus = list.deletedStatus,
      source = list.source;
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 || !isSameDay(Number(taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT11 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT11 === void 0 ? void 0 : (_taskTrackerData$getT12 = _taskTrackerData$getT11.taskTrackerDatas[index - 1]) === null || _taskTrackerData$getT12 === void 0 ? void 0 : _taskTrackerData$getT12.taskDate), Number(list === null || list === void 0 ? void 0 : list.taskDate)) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: "4",
      className: "task-tracker-date-td"
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-date-divider-label-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-tracker-list-date-divider-label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "manual-time-date-divider-label-icon"
    }, /*#__PURE__*/React.createElement(MdDateRange, null)), /*#__PURE__*/React.createElement("span", null, isToday(Number(taskDate)) ? "Today" : isYesterday(Number(taskDate)) ? "Yesterday" : format(Number(taskDate), "d-LLL-yyyy")))))) : null, index === 0 ? /*#__PURE__*/React.createElement("tr", {
      className: "project-task-time-mapping-table-header"
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "left"
      }
    }, "Task Details"), /*#__PURE__*/React.createElement("td", null, "Worked Hours"), /*#__PURE__*/React.createElement("td", null, "Worked Time"), /*#__PURE__*/React.createElement("td", null), (role != "Member" || role == "Member" && (allowEmployeesToEditTaskTimes || allowEmployeesToEditTaskTimes == undefined)) && user.userId === user.userId && endTime !== null ? /*#__PURE__*/React.createElement("td", null) : null) : null, /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: classNames("project-task-time-mapping-table-data-details", {
        "project-task-time-mapping-table-data-details-selected-color": endTime === null,
        "project-task-time-mapping-table-data-details-row-disabled-style": deletedStatus == "DELETED"
      })
    }, /*#__PURE__*/React.createElement("td", {
      className: "task-tracker-data-td-task-name task-tracker-data-td-task-name-timeline"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, projectName, " : ", taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-table-list-task-name project-task-time-mapping-table-list-timeline-task-name"
    }, /*#__PURE__*/React.createElement("span", null, projectName, " : ", taskName))), /*#__PURE__*/React.createElement("div", null, taskDescription ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskDescription)
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-task-tracker-table-description-details-root"
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-task-time-mapping-task-tracker-table-description-details "
    }, taskDescription), " ")) : null)), /*#__PURE__*/React.createElement("td", {
      className: ""
    }, endTime ? totalTime : "-"
    // moment.duration(new moment().diff(new moment(startTime))).humanize()
    ), /*#__PURE__*/React.createElement("td", {
      className: "project-task-time-mapping-task-list-start-end-time"
    }, moment(startTime).format("hh:mm A"), " -", " ", endTime === null ? user.userId === user.userId ? /*#__PURE__*/React.createElement("span", null, "Ongoing") : /*#__PURE__*/React.createElement("span", {
      className: "project-task-time-mapping-table-ongoing-others"
    }, " Ongoing") : moment(endTime).format("hh:mm A")), /*#__PURE__*/React.createElement("td", null, endTime === null && (source === "desktop" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "This task can only be stopped from the desktop app.")
    }, /*#__PURE__*/React.createElement("span", {
      className: "d-inline-block"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      className: "project-task-time-mapping-table-task-list-stop-again-button",
      disabled: true,
      style: {
        pointerEvents: "none"
      }
    }, /*#__PURE__*/React.createElement(MdAdjust, {
      className: "project-task-time-mapping-table-task-list-start-again-icon"
    }), "Stop Task"))) : !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer) ? /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      className: "project-task-time-mapping-table-task-list-stop-again-button",
      disabled: desktopLoader || deletedStatus === "DELETED",
      onClick: function onClick() {
        return handleEndTimeShow({
          endTime: endTime,
          organisationId: organisationId,
          teamId: teamId,
          projectId: projectId,
          taskId: taskId,
          taskTimeId: taskTimeId,
          startTime: startTime,
          taskDate: taskDate
        });
      }
    }, /*#__PURE__*/React.createElement(MdAdjust, {
      className: "project-task-time-mapping-table-task-list-start-again-icon"
    }), "Stop Task") : organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer && isToday(Number(taskDate)) ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Click to stop the task. The current time will be recorded as the end time.")
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      className: "project-task-time-mapping-table-task-list-stop-again-button",
      disabled: loadingTaskId === taskTimeId || deletedStatus === "DELETED",
      onClick: function onClick() {
        return handleStopTimeSubmit({
          endTime: endTime,
          organisationId: organisationId,
          teamId: teamId,
          projectId: projectId,
          taskId: taskId,
          taskTimeId: taskTimeId,
          startTime: startTime,
          taskDate: taskDate,
          projectName: projectName,
          taskName: taskName
        });
      }
    }, loadingTaskId === taskTimeId ? "Loading..." : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MdAdjust, {
      className: "project-task-time-mapping-table-task-list-start-again-icon"
    }), "Stop Task"))) : role == "Admin" ? /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      className: "project-task-time-mapping-table-task-list-stop-again-button",
      disabled: desktopLoader || deletedStatus === "DELETED",
      onClick: function onClick() {
        return handleEndTimeShow({
          endTime: endTime,
          organisationId: organisationId,
          teamId: teamId,
          projectId: projectId,
          taskId: taskId,
          taskTimeId: taskTimeId,
          startTime: startTime,
          taskDate: taskDate
        });
      }
    }, /*#__PURE__*/React.createElement(MdAdjust, {
      className: "project-task-time-mapping-table-task-list-start-again-icon"
    }), "Stop Task") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      className: "project-task-time-mapping-table-task-list-stop-again-button project-task-time-mapping-table-task-list-stop-again-warning-button",
      disabled: desktopLoader || deletedStatus === "DELETED",
      onClick: function onClick() {
        setShowStopTaskWarningModal(taskDate);
      }
    }, /*#__PURE__*/React.createElement(MdAdjust, {
      className: "project-task-time-mapping-table-task-list-start-again-icon"
    }), "Stop Task"), /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      className: "project-task-time-mapping-table-task-list-stop-again-button add-my-task-delete-button",
      disabled: desktopLoader || deletedStatus === "DELETED",
      onClick: function onClick() {
        return handleDeleteShow(list);
      }
    }, /*#__PURE__*/React.createElement(MdDelete, {
      className: "project-task-time-mapping-table-task-list-start-again-icon"
    }), "Delete Task"))), deletedStatus == "DELETED" ? /*#__PURE__*/React.createElement("div", {
      className: "edit-setting-card-table-data-icon-my-task-deleted-text"
    }, "Deleted") : null), (role != "Member" || role == "Member" && (allowEmployeesToEditTaskTimes || allowEmployeesToEditTaskTimes == undefined)) && user.userId === user.userId && endTime !== null && deletedStatus !== "DELETED" ? /*#__PURE__*/React.createElement("td", {
      className: "edit-setting-card-table-data-icon"
    }, /*#__PURE__*/React.createElement(EditMenuIcon, {
      organisationId: organisationId,
      handleShow: handleShow,
      list: list,
      handleDeleteShow: handleDeleteShow
    })) : /*#__PURE__*/React.createElement("td", null)));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "no-data-risk-setting"
  }, "No task found."), taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT13 = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT13 !== void 0 && (_taskTrackerData$getT14 = _taskTrackerData$getT13.taskTrackerDatas) !== null && _taskTrackerData$getT14 !== void 0 && _taskTrackerData$getT14.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : planName == "free" ? /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "On the free plan, you can access the last 14 days of data only. Upgrade to the Pro plan to get the historical data.", " ") : /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "You have seen all the tasks")) : null, /*#__PURE__*/React.createElement(EditViewerModal, {
    EditViewerShow: EditViewerShow,
    handleClose: handleClose,
    organisationId: organisationId,
    teamId: teamId,
    organisationSettings: organisationSettings,
    projectListing: projectListing,
    taskRefetch: taskRefetch,
    from: from,
    userIds: userIds,
    projectIds: projectIds,
    taskIds: taskIds,
    userId: user.userId,
    propsFrom: from,
    planName: planName,
    last14Days: last14Days,
    role: role
  }), /*#__PURE__*/React.createElement(DeleteTaskModal, {
    showDeleteModal: showDeleteModal,
    handleDeleteClose: handleDeleteClose,
    organisationId: organisationId,
    taskRefetch: taskRefetch,
    setIsAllLoaded: setIsAllLoaded,
    projectIds: projectIds,
    taskIds: taskIds,
    userId: user.userId,
    teamId: teamId,
    planName: planName,
    last14Days: last14Days,
    role: role,
    user: user
  }), /*#__PURE__*/React.createElement(EndTaskTimeModal, {
    showEndTimeModal: showEndTimeModal,
    handleEndTimeClose: handleEndTimeClose,
    organisationSettings: organisationSettings,
    user: user,
    teamId: teamId,
    planName: planName,
    last14Days: last14Days,
    role: role,
    type: "",
    limit: LIMIT,
    projectIds: null,
    taskIds: null,
    userIds: null
  }), /*#__PURE__*/React.createElement(StopTaskWarningModal, {
    showStopTaskWarningModal: showStopTaskWarningModal,
    setShowStopTaskWarningModal: setShowStopTaskWarningModal,
    handleStopTaskWarningClose: handleStopTaskWarningClose
  }));
};
var StopTaskWarningModal = function StopTaskWarningModal(props) {
  var showStopTaskWarningModal = props.showStopTaskWarningModal,
    handleStopTaskWarningClose = props.handleStopTaskWarningClose;

  //console.log({ showStopTaskWarningModal });

  if (showStopTaskWarningModal === null) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleStopTaskWarningClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Action required: task not ended")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, /*#__PURE__*/React.createElement("div", null, " You started a task on ", format(Number(showStopTaskWarningModal), "d-LLL-yyyy"), ", but it was not ended on the same day. Manual end time entry is not allowed once the date changes."), /*#__PURE__*/React.createElement("div", {
    className: "add-task-modal-warning-text"
  }, "To continue, please contact your administrator to add the end time, or delete this task.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleStopTaskWarningClose
  }, "Close")));
};
export var EndTaskTimeModal = function EndTaskTimeModal(props) {
  var showEndTimeModal = props.showEndTimeModal,
    handleEndTimeClose = props.handleEndTimeClose,
    organisationSettings = props.organisationSettings,
    user = props.user,
    teamId = props.teamId,
    planName = props.planName,
    last14Days = props.last14Days,
    role = props.role,
    type = props.type,
    limit = props.limit,
    projectIds = props.projectIds,
    taskIds = props.taskIds,
    userIds = props.userIds;
  if (showEndTimeModal == null) {
    return null;
  }
  var organisationId = showEndTimeModal.organisationId,
    projectId = showEndTimeModal.projectId,
    taskId = showEndTimeModal.taskId,
    taskTimeId = showEndTimeModal.taskTimeId,
    startTime = showEndTimeModal.startTime,
    taskDate = showEndTimeModal.taskDate;
  var dateTemp = moment(taskDate).format("DD/MM/YYYY");
  var statTimeTemp = moment(startTime).format("HH:mm");
  var startTimeValue = moment(dateTemp + " " + statTimeTemp, "DD/MM/YYYY HH:mm").valueOf();
  var orgNow = moment().tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var selectedDate = moment(taskDate).tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var timeTemp = moment().tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("HH:mm");
  var isToday = selectedDate.format("YYYY-MM-DD") === orgNow.format("YYYY-MM-DD");
  var _React$useState71 = React.useState(taskDate),
    _React$useState72 = _slicedToArray(_React$useState71, 2),
    manualStartDate = _React$useState72[0],
    setManualStartDate = _React$useState72[1];
  var _React$useState73 = React.useState(false),
    _React$useState74 = _slicedToArray(_React$useState73, 2),
    isManualDatePickerOpen = _React$useState74[0],
    setIsManualDatePickerOpen = _React$useState74[1];
  var _React$useState75 = React.useState(!isToday ? undefined : moment(dateTemp + " " + timeTemp, "DD/MM/YYYY HH:mm")),
    _React$useState76 = _slicedToArray(_React$useState75, 2),
    modalValueEndTime = _React$useState76[0],
    setModalValueEndTime = _React$useState76[1];
  var _React$useState77 = React.useState(moment(startTime)),
    _React$useState78 = _slicedToArray(_React$useState77, 2),
    modalValueStartTime = _React$useState78[0],
    setModalValueStartTime = _React$useState78[1];
  var _React$useState79 = React.useState(!isToday ? null : moment(dateTemp + " " + timeTemp, "DD/MM/YYYY HH:mm").valueOf()),
    _React$useState80 = _slicedToArray(_React$useState79, 2),
    modalDateEndTime = _React$useState80[0],
    setModalDateEndTime = _React$useState80[1];
  var _React$useState81 = React.useState(startTimeValue),
    _React$useState82 = _slicedToArray(_React$useState81, 2),
    modalDateStartTime = _React$useState82[0],
    setModalDateStartTime = _React$useState82[1];
  var _React$useState83 = React.useState(""),
    _React$useState84 = _slicedToArray(_React$useState83, 2),
    modalEndTime = _React$useState84[0],
    setModalEndTime = _React$useState84[1];
  var _React$useState85 = React.useState(null),
    _React$useState86 = _slicedToArray(_React$useState85, 2),
    endTimeTemp = _React$useState86[0],
    setEndTimeTemp = _React$useState86[1];
  var _React$useState87 = React.useState(false),
    _React$useState88 = _slicedToArray(_React$useState87, 2),
    projectError = _React$useState88[0],
    setProjectError = _React$useState88[1];
  var _React$useState89 = React.useState(false),
    _React$useState90 = _slicedToArray(_React$useState89, 2),
    endTimeErr = _React$useState90[0],
    setEndTimeErr = _React$useState90[1];
  var _React$useState91 = React.useState(null),
    _React$useState92 = _slicedToArray(_React$useState91, 2),
    startTimeTemp = _React$useState92[0],
    setStartTimeTemp = _React$useState92[1];
  var _useMutation5 = useMutation(ADD_PROJECT_AND_TASK_END_TIME_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    addProjectAndTaskEndTime = _useMutation6[0],
    addProjectAndTaskEndTimeLoading = _useMutation6[1].loading;
  var handleEndTimeSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values, _ref9) {
      var resetForm, variables, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            resetForm = _ref9.resetForm;
            if (modalValueEndTime == null) {
              setProjectError(true);
            }
            if (!(modalValueEndTime < startTime)) {
              _context3.next = 5;
              break;
            }
            setEndTimeErr(true);
            return _context3.abrupt("return");
          case 5:
            //console.log({ modalValueEndTime, modalValueStartTime });
            //return null;
            variables = {
              projectId: projectId,
              taskId: taskId,
              organisationId: organisationId,
              taskTimeId: taskTimeId,
              timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              startTime: moment(modalValueStartTime).format("HH:mm"),
              endTime: moment(modalValueEndTime).format("HH:mm"),
              taskDate: moment(taskDate).valueOf(),
              newTaskDate: manualStartDate != taskDate ? moment(manualStartDate).valueOf() : null
            };
            _context3.prev = 6;
            _context3.next = 9;
            return addProjectAndTaskEndTime({
              variables: variables,
              // awaitRefetchQueries: true,
              // refetchQueries: [
              //   {
              //     query: GET_TASK_TRACKER_QUERY,
              //     variables: {
              //       organisationId,
              //       teamId,
              //       userId: type == "work-history" ? userIds.length ? userIds: null : [user.userId],
              //       projectId: type == "work-history" ? projectIds.length ? projectIds : null :null,
              //       taskId: type == "work-history" ? taskIds.length ? taskIds : null : null,
              //       limit: limit,
              //       offset: 0,
              //       freePlanStartDate: planName == "free" ? (last14Days ? last14Days[0] : null) : null,
              //       freePlanEndDate: planName == "free" ? (last14Days ? last14Days[1] : null) : null,
              //       role,
              //       entryStatus : "",
              //     },
              //   },
              // ],
              update: function update(cache, _ref11) {
                var data = _ref11.data;
                var response = data === null || data === void 0 ? void 0 : data.addProjectAndTaskEndTime;
                if (!response) return;

                // Use the edited values (not "now")
                var endDateTime = moment("".concat(moment(variables.taskDate).format("YYYY-MM-DD"), " ").concat(variables.endTime), "YYYY-MM-DD HH:mm").tz(variables.timezone || moment.tz.guess()).toISOString();
                var newStartDateTime = moment("".concat(moment(variables.newTaskDate || variables.taskDate).format("YYYY-MM-DD"), " ").concat(variables.startTime), "YYYY-MM-DD HH:mm").tz(variables.timezone || moment.tz.guess()).toISOString();
                cache.modify({
                  fields: {
                    getTaskTrackerDetails: function getTaskTrackerDetails() {
                      var existingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      var _ref12 = arguments.length > 1 ? arguments[1] : undefined,
                        readField = _ref12.readField;
                      if (!(existingData !== null && existingData !== void 0 && existingData.taskTrackerDatas)) return existingData;
                      return _objectSpread(_objectSpread({}, existingData), {}, {
                        taskTrackerDatas: existingData.taskTrackerDatas.map(function (taskRef) {
                          var taskTimeId = readField("taskTimeId", taskRef);
                          if (taskTimeId !== variables.taskTimeId) {
                            return taskRef;
                          }

                          // ---- RECALCULATE TOTAL TIME ----
                          var totalTimeInSec = Math.max(0, Math.round(moment.duration(moment(endDateTime).diff(moment(newStartDateTime))).asSeconds()));
                          var formatTotalTime = function formatTotalTime(seconds) {
                            var hours = Math.floor(seconds / 3600);
                            var minutes = Math.floor(seconds % 3600 / 60);
                            return "".concat(String(hours).padStart(2, "0"), "h ").concat(String(minutes).padStart(2, "0"), "m");
                          };

                          // ---- RETURN UPDATED TASK ----
                          return _objectSpread(_objectSpread({}, taskRef), {}, {
                            startTime: newStartDateTime,
                            endTime: endDateTime,
                            taskDate: variables.newTaskDate || variables.taskDate,
                            totalTimeInSec: totalTimeInSec,
                            totalTime: formatTotalTime(totalTimeInSec)
                          });
                        })
                      });
                    }
                  }
                });
              }
            });
          case 9:
            response = _context3.sent;
            if (response && response.data && response.data.addProjectAndTaskEndTime !== "") {
              toast.success("End time updated successfully!");
              setModalValueEndTime(undefined);
              setModalEndTime("");
              setEndTimeTemp(null);
              setModalDateEndTime(null);
              offsets = 0;
              resetForm({});
              handleEndTimeClose();
            } else {
              toast.error("Error Occured, try again!");
            }
            _context3.next = 16;
            break;
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](6);
            setProjectError(true);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[6, 13]]);
    }));
    return function (_x4, _x5) {
      return _ref10.apply(this, arguments);
    };
  }(), [addProjectAndTaskEndTime, addProjectAndTaskEndTimeLoading, modalValueStartTime, modalValueEndTime, manualStartDate]);
  var startOnChange = function startOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setModalValueStartTime(value);
      setModalStartTime(finalTime);
      setFieldValue("startTime", finalTime);
    } else {
      setModalStartTime("");
      setFieldValue("startTime", "");
    }
  };
  var endOnChange = function endOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      var _dateTemp = moment(manualStartDate).format("DD/MM/YYYY");
      setModalValueEndTime(value);
      setModalEndTime(finalTime);
      setFieldValue("endTime", finalTime);
      setModalDateEndTime(moment(_dateTemp + " " + finalTime, "DD/MM/YYYY HH:mm").valueOf());
    } else {
      setModalValueEndTime(undefined);
      setModalEndTime("");
      setFieldValue("endTime", "");
      setModalDateEndTime(null);
    }
  };
  var handleChange = function handleChange(e) {
    setIsManualDatePickerOpen(!isManualDatePickerOpen);
    setManualStartDate(e);
    //modalDateStartTime, setModalDateStartTime
    var dateTemp = moment(e).format("DD/MM/YYYY");
    var statTimeTemp = moment(modalValueStartTime).format("HH:mm");
    setModalDateStartTime(moment(dateTemp + " " + statTimeTemp, "DD/MM/YYYY HH:mm").valueOf());
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleEndTimeClose,
    centered: true,
    dialog: true,
    dialogClassName: "modal-80w",
    backdrop: "static"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-task-time-mapping-modal-edit-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-time-mapping-modal-edit-end-time-header-name"
  }, "Stop Task")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-task-time-mapping-modal-edit-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      startTime: moment(startTime),
      endTime: !isToday ? "" : moment(dateTemp + " " + timeTemp, "DD/MM/YYYY HH:mm").tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).valueOf()
    },
    enableReinitialize: true
    // validateOnChange={false}
    ,
    validateOnBlur: false,
    validationSchema: EditTaskSchema,
    onSubmit: handleEndTimeSubmit
  }, function (_ref13) {
    var setFieldValue = _ref13.setFieldValue,
      isSubmitting = _ref13.isSubmitting,
      errors = _ref13.errors,
      touched = _ref13.touched,
      values = _ref13.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-formik-edit-form-end-time"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "startTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "task-tracker-edit-label project-task-time-mapping-formik-add-form-label"
      }, "Start Time"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "startTime",
        value: modalValueStartTime,
        className: meta.error && meta.touched ? "project-task-time-mappicng-formik-add-form-start-time-error" : "project-task-time-mapping-formik-add-form-start-time stop-task-edit-start-time",
        onChange: function onChange(e) {
          startOnChange(e, setFieldValue);
          setStartTimeTemp(e);
        },
        placeholder: "Start Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null
        // inputReadOnly
        ,
        disabled: true
        // disabledHours={disabledStartTimeHours}
        // disabledMinutes={disabledStartTimeMinutes}
      })));
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "endTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "task-tracker-edit-label project-task-time-mapping-formik-add-form-label"
      }, "End Time"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "endTime",
        value: modalValueEndTime,
        className: meta.error && meta.touched ? "project-task-time-mapping-formik-add-form-end-time-error" : "project-task-time-mapping-formik-add-form-end-time",
        onChange: function onChange(e) {
          endOnChange(e, setFieldValue);
          setEndTimeTemp(e);
        },
        placeholder: "End Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined
        // clearIcon={null}
        // inputReadOnly
        // disabledHours={disabledHours}
        // disabledMinutes={disabledMinutes}
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-edit-task-date project-task-time-mapping-edit-time-div project-task-time-mapping-edit-end-time-div"
    }, /*#__PURE__*/React.createElement("label", {
      className: "task-tracker-edit-label project-task-time-mapping-formik-add-form-label"
    }, "Date"), " ", /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-calender-div manual-page-content-wrapper-filter-date-date-section"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      trigger: "click",
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Popover, {
        className: "project-task-time-mapping-wrapper-menu-filter-overlay-trigger"
      }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(DatePicker, {
        selected: manualStartDate,
        onChange: handleChange,
        open: isManualDatePickerOpen,
        inline: true,
        maxDate: new Date()
      })))
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-calender-icon-div"
    }, /*#__PURE__*/React.createElement(GoCalendar, {
      className: "project-task-time-mapping-section-calender-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "project-task-time-mapping-section-calender-text"
    }, arrayToStringOutput([manualStartDate, manualStartDate], organisationSettings.organisationTimezone))))))), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-formik-edit-form-edit-end-time"
    }, modalDateEndTime != null && modalDateEndTime < modalDateStartTime ? "End time should be greater than the start time" : ""), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-project-formik-edit-save-button-div"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      className: "project-task-time-mapping-project-formik-edit-save-button",
      type: "submit",
      disabled: addProjectAndTaskEndTimeLoading || modalDateEndTime != null && modalDateEndTime < modalDateStartTime ? true : false
    }, addProjectAndTaskEndTimeLoading ? "Loading..." : "Click to Stop Task")));
  })));
};
var EditMenuIcon = function EditMenuIcon(props) {
  var organisationId = props.organisationId,
    handleShow = props.handleShow,
    list = props.list,
    handleDeleteShow = props.handleDeleteShow;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "task-tracker-edit-menus"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(HiOutlineDotsVertical, {
    className: "task-tracker-edit-menus-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "edit-task-history",
    onClick: function onClick() {
      return handleShow(list);
    }
  }, "Edit"), /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "manage-teams-edit-menus-delete-icon",
    onClick: function onClick() {
      return handleDeleteShow(list);
    }
  }, "Delete"))));
};
var EditViewerModal = function EditViewerModal(props) {
  var EditViewerShow = props.EditViewerShow,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    teamId = props.teamId,
    organisationSettings = props.organisationSettings,
    projectListing = props.projectListing,
    taskRefetch = props.taskRefetch,
    userIds = props.userIds,
    projectIds = props.projectIds,
    taskIds = props.taskIds,
    userId = props.userId,
    from = props.from,
    propsFrom = props.propsFrom,
    planName = props.planName,
    last14Days = props.last14Days,
    role = props.role;
  if (EditViewerShow == null) {
    return null;
  }
  var projectId = EditViewerShow.projectId,
    projectName = EditViewerShow.projectName,
    taskId = EditViewerShow.taskId,
    taskName = EditViewerShow.taskName,
    taskTimeId = EditViewerShow.taskTimeId,
    taskDate = EditViewerShow.taskDate,
    startTime = EditViewerShow.startTime,
    endTime = EditViewerShow.endTime,
    taskDescription = EditViewerShow.taskDescription;
  var _React$useState93 = React.useState(false),
    _React$useState94 = _slicedToArray(_React$useState93, 2),
    datePickerOpen = _React$useState94[0],
    setdatePickerOpen = _React$useState94[1];
  var _React$useState95 = React.useState({
      projectId: projectId,
      projectName: projectName,
      taskId: taskId,
      taskName: taskName
    }),
    _React$useState96 = _slicedToArray(_React$useState95, 2),
    editAddedShow = _React$useState96[0],
    setEditAddedShow = _React$useState96[1];
  var _React$useState97 = React.useState(false),
    _React$useState98 = _slicedToArray(_React$useState97, 2),
    isNavClick = _React$useState98[0],
    setNavClick = _React$useState98[1];
  var _React$useState99 = React.useState(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.taskDate),
    _React$useState100 = _slicedToArray(_React$useState99, 2),
    taskStartDate = _React$useState100[0],
    setTaskStartDate = _React$useState100[1];
  var _React$useState101 = React.useState(false),
    _React$useState102 = _slicedToArray(_React$useState101, 2),
    isTaskDatePickerOpen = _React$useState102[0],
    setIsTaskDatePickerOpen = _React$useState102[1];
  var _React$useState103 = React.useState(false),
    _React$useState104 = _slicedToArray(_React$useState103, 2),
    projectError = _React$useState104[0],
    setProjectError = _React$useState104[1];
  var _React$useState105 = React.useState(moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.startTime).format("HH:mm")),
    _React$useState106 = _slicedToArray(_React$useState105, 2),
    editStartTime = _React$useState106[0],
    setEditStartTime = _React$useState106[1];
  var _React$useState107 = React.useState(moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.endTime).format("HH:mm")),
    _React$useState108 = _slicedToArray(_React$useState107, 2),
    editEndTime = _React$useState108[0],
    setEditEndTime = _React$useState108[1];
  var _React$useState109 = React.useState(moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.startTime)),
    _React$useState110 = _slicedToArray(_React$useState109, 2),
    editValueStartTime = _React$useState110[0],
    setEditValueStartTime = _React$useState110[1];
  var _React$useState111 = React.useState(moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.endTime)),
    _React$useState112 = _slicedToArray(_React$useState111, 2),
    editValueEndTime = _React$useState112[0],
    setEditValueEndTime = _React$useState112[1];
  var _React$useState113 = React.useState(taskDate),
    _React$useState114 = _slicedToArray(_React$useState113, 2),
    editManualStartDate = _React$useState114[0],
    setEditManualStartDate = _React$useState114[1];
  var _React$useState115 = React.useState(false),
    _React$useState116 = _slicedToArray(_React$useState115, 2),
    isEditManualDatePickerOpen = _React$useState116[0],
    setIsEditManualDatePickerOpen = _React$useState116[1];
  var _useMutation7 = useMutation(EDIT_PROJECT_AND_TASK_TIMER_DETAILS_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    editProjectTaskDetails = _useMutation8[0],
    editProjectTaskLoading = _useMutation8[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values) {
      var taskDescription, projectId, projectName, taskId, taskName, editStartTime, editEndTime, variables, _response$data3, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            taskDescription = values.taskDescription, projectId = values.projectId, projectName = values.projectName, taskId = values.taskId, taskName = values.taskName, editStartTime = values.editStartTime, editEndTime = values.editEndTime;
            variables = {
              organisationId: organisationId,
              taskDate: moment(taskStartDate).valueOf(),
              taskTimeId: EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.taskTimeId,
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              oldProjectId: EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.projectId,
              oldTaskId: EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.taskId,
              taskDescription: taskDescription,
              projectId: editAddedShow === null || editAddedShow === void 0 ? void 0 : editAddedShow.projectId,
              projectName: editAddedShow === null || editAddedShow === void 0 ? void 0 : editAddedShow.projectName,
              taskId: editAddedShow === null || editAddedShow === void 0 ? void 0 : editAddedShow.taskId,
              taskName: editAddedShow === null || editAddedShow === void 0 ? void 0 : editAddedShow.taskName,
              startTime: moment(editStartTime).format("HH:mm"),
              endTime: moment(editEndTime).format("HH:mm"),
              newTaskDate: moment(editManualStartDate).valueOf()
            };
            _context4.prev = 2;
            _context4.next = 5;
            return editProjectTaskDetails({
              variables: variables,
              // update(cache, { data }) {
              //     const updatedTask = data?.editProjectAndTaskTimerDetails;
              //     if (!updatedTask) return;
              //     cache.modify({
              //       fields: {
              //         getTaskTrackerDetails(existingData = {}, { readField }) {
              //           if (!existingData?.taskTrackerDatas) return existingData;
              //           const updatedTaskList = existingData.taskTrackerDatas.map(
              //             (taskRef) => {
              //               const taskTimeId = readField("taskTimeId", taskRef);
              //               if (taskTimeId === updatedTask.taskTimeId) {
              //                 return {
              //                   ...taskRef,
              //                   startTime: updatedTask.startTime,
              //                   endTime: updatedTask.endTime,
              //                   taskDescription: updatedTask.taskDescription,
              //                   projectId: updatedTask.projectId,
              //                   taskId: updatedTask.taskId,
              //                   taskDate: updatedTask.taskDate,
              //                   projectName: updatedTask.projectName,
              //                   taskName: updatedTask.taskName,
              //                 };
              //               }
              //               return taskRef;
              //             }
              //           );
              //           return {
              //             ...existingData,
              //             taskTrackerDatas: updatedTaskList,
              //           };
              //         },
              //       },
              //     });
              //   },
              update: function update(cache, _ref15) {
                var data = _ref15.data;
                var updatedTask = data === null || data === void 0 ? void 0 : data.editProjectAndTaskTimerDetails;
                if (!updatedTask) return;

                //console.log({updatedTask})
                // const id = cache.identify({
                //   __typename: "TaskTrackerDatas", // confirm in Apollo DevTools
                //   taskTimeId: updatedTask.taskTimeId,
                // });

                // console.log({updatedTask})
                // if (!id) {
                //   console.log("Cache ID not found");
                //   return;
                // }

                cache.modify({
                  fields: {
                    getTaskTrackerDetails: function getTaskTrackerDetails() {
                      var existingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      var _ref16 = arguments.length > 1 ? arguments[1] : undefined,
                        readField = _ref16.readField;
                      if (!(existingData !== null && existingData !== void 0 && existingData.taskTrackerDatas)) return existingData;
                      var updatedList = existingData.taskTrackerDatas.map(function (taskRef) {
                        var taskTimeId = readField("taskTimeId", taskRef);
                        if (taskTimeId !== updatedTask.taskTimeId) return taskRef;
                        var existingStartTime = readField("startTime", taskRef);
                        var taskDate = readField("taskDate", taskRef);

                        // ✅ Combine date + time safely
                        var taskDateMoment = variables.newTaskDate ? moment(variables.newTaskDate) : null;
                        var startDateTime = variables.startTime ? moment("".concat(taskDateMoment.format("DD/MM/YYYY"), " ").concat(variables.startTime), "DD/MM/YYYY HH:mm").toISOString() : null;
                        var endDateTime = variables.endTime ? moment("".concat(taskDateMoment.format("DD/MM/YYYY"), " ").concat(variables.endTime), "DD/MM/YYYY HH:mm").toISOString() : null;
                        var totalTimeInSec = endDateTime ? Math.round(moment.duration(moment(endDateTime).diff(moment(startDateTime))).asSeconds()) : 0;
                        var formatTotalTime = function formatTotalTime(seconds) {
                          if (!seconds || seconds <= 0) return "00h 00m";
                          var hours = Math.floor(seconds / 3600);
                          var minutes = Math.floor(seconds % 3600 / 60);
                          return "".concat(String(hours).padStart(2, "0"), "h ").concat(String(minutes).padStart(2, "0"), "m");
                        };
                        var totalTimeFormatted = formatTotalTime(totalTimeInSec);
                        return _objectSpread(_objectSpread({}, taskRef), {}, {
                          startTime: startDateTime,
                          endTime: endDateTime,
                          taskDescription: updatedTask.taskDescription,
                          projectId: updatedTask.projectId,
                          taskId: updatedTask.taskId,
                          taskDate: updatedTask.taskDate,
                          projectName: updatedTask.projectName || (editAddedShow === null || editAddedShow === void 0 ? void 0 : editAddedShow.projectName),
                          taskName: updatedTask.taskName || (editAddedShow === null || editAddedShow === void 0 ? void 0 : editAddedShow.taskName),
                          totalTimeInSec: totalTimeInSec,
                          totalTime: totalTimeFormatted
                        });
                      });
                      return _objectSpread(_objectSpread({}, existingData), {}, {
                        taskTrackerDatas: updatedList
                      });
                    }
                  }
                });
              }
            });
          case 5:
            response = _context4.sent;
            if (response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.editProjectAndTaskTimerDetails) {
              toast.success("Task updated successfully!");
              // taskRefetch?.();
              handleClose();
            } else {
              toast.error("Error updating task!");
            }
            _context4.next = 13;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](2);
            console.log(_context4.t0);
            toast.error(isRateLimited(_context4.t0) ? rateLimitMessage(_context4.t0) : "Error updating task!");
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 9]]);
    }));
    return function (_x6) {
      return _ref14.apply(this, arguments);
    };
  }(), [editProjectTaskDetails, editProjectTaskLoading, editManualStartDate, editAddedShow]);
  var handleChange = function handleChange(e) {
    setIsEditManualDatePickerOpen(!isEditManualDatePickerOpen);
    setEditManualStartDate(e);
  };
  var startOnChange = function startOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours <= 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setEditValueStartTime(value);
      setEditStartTime(finalTime);
      // setFieldValue("startTime", finalTime);

      // setFieldValue("editStartTime", finalTime);
    } else {
      setEditValueStartTime(undefined);
      setEditStartTime("");
      // setFieldValue("startTime", "");
      // setFieldValue("editStartTime", "");
    }
  };
  var endOnChange = function endOnChange(value, setFieldValue, taskIndex) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours <= 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setEditValueEndTime(value);
      setEditEndTime(finalTime);
    } else {
      setEditValueEndTime(undefined);
      setEditEndTime("");
      setFieldValue("editEndTime", "");
    }
  };
  var defaultValues = {
    projectId: projectId,
    projectName: projectName,
    taskId: taskId,
    taskName: taskName,
    editStartTime: moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.startTime),
    editEndTime: moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.endTime),
    taskDescription: taskDescription !== null && taskDescription !== void 0 ? taskDescription : ""
  };
  var errorMessage = function errorMessage(errors, touched, name) {
    var error = getIn(errors, name);
    var touch = getIn(touched, name);
    if (touch && error) {
      return /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, error);
    }
    return null;
  };
  function check12PmStatus(value, startTimeHour, endTimeHour, startTimeData, endTimeHourData) {
    if (value == 24 && startTimeHour <= 12 && endTimeHour >= 12 && (startTimeData == "pm" || endTimeHourData == "pm")) {
      return false;
    }
    return true;
  }
  function disabledHours() {
    var startTimeHour = moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.startTime).format("HH");
    var startTimeData = moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.startTime).format("a");
    var endTimeHour = moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.endTime).format("HH");
    var endTimeHourData = moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.endTime).format("a");
    var disabledHoursArray = [];
    for (var value = 0; value <= 24; value++) {
      if (check12PmStatus(value, startTimeHour, endTimeHour, startTimeData, endTimeHourData) && (value < Number(startTimeHour) || value > Number(endTimeHour))) {
        disabledHoursArray.push(value);
      }
    }
    return disabledHoursArray;
  }
  function generateOptions(length, excludedOptions) {
    var arr = [];
    for (var value = 0; value < length; value++) {
      if (excludedOptions.indexOf(value) > 0) {
        arr.push(value);
      }
    }
    return arr;
  }
  function disabledMinutes(h) {
    var startTimeHour = moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.startTime).format("HH");
    var endTimeHour = moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.endTime).format("HH");
    var startTimeMins = moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.startTime).format("mm");
    var endTimeMins = moment(EditViewerShow === null || EditViewerShow === void 0 ? void 0 : EditViewerShow.endTime).format("mm");
    var startExcludeTime = [];
    var endExcludeTime = [];
    var defaultExcludeTime = [];
    for (var value = 0; value < 60; value++) {
      if (value < Number(startTimeMins)) {
        startExcludeTime.push(value);
      }
      defaultExcludeTime.push(value);
    }
    for (var _value = 0; _value < 60; _value++) {
      if (_value > Number(endTimeMins)) {
        endExcludeTime.push(_value);
      }
    }
    if (startTimeHour == endTimeHour) {
      startExcludeTime = [].concat(_toConsumableArray(startExcludeTime), _toConsumableArray(endExcludeTime));
      endExcludeTime = [].concat(_toConsumableArray(startExcludeTime), _toConsumableArray(endExcludeTime));
    }
    switch (h) {
      case Number(startTimeHour):
        return generateOptions(60, startExcludeTime);
      case Number(endTimeHour):
        return generateOptions(60, endExcludeTime);
      default:
        return generateOptions(60, []);
    }
  }

  //  ${
  //   values?.endTime < values?.startTime || !values?.endTime
  //     ? "desktop-home-project-formik-edit-end-time"
  //     : ""
  // }

  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true,
    dialog: true,
    size: "md",
    backdrop: "static"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-task-time-mapping-modal-edit-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-time-mapping-modal-edit-header-name"
  }, "Edit Task")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: ""
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: defaultValues,
    validationSchema: EditSchema,
    onSubmit: handleSubmit
  }, function (_ref17) {
    var setFieldValue = _ref17.setFieldValue,
      isSubmitting = _ref17.isSubmitting,
      values = _ref17.values,
      errors = _ref17.errors,
      touched = _ref17.touched;
    var startTimeError = errorMessage(errors, touched, "tasks.startTime");
    var endTimeError = errorMessage(errors, touched, "tasks.endTime");
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: {
        span: 12,
        offset: 0
      },
      md: {
        span: 12,
        offset: 0
      },
      lg: {
        span: 12,
        offset: 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-tracker-edit-modal-row project-task-time-mapping-edit-time-div"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "task-tracker-edit-label"
    }, "Project & Task"), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-added",
        className: "project-tooltip-start"
      }, editAddedShow === null || editAddedShow === void 0 ? void 0 : editAddedShow.projectName, " ", editAddedShow !== null && editAddedShow !== void 0 && editAddedShow.taskName ? " - ".concat(editAddedShow === null || editAddedShow === void 0 ? void 0 : editAddedShow.taskName) : "")
    }, /*#__PURE__*/React.createElement(Dropdown, {
      open: isNavClick,
      className: classNames("edit-task-project-task-time-mapping-formik-add-project-button", "edit-taskproject-task-time-mapping-formik-add-project-button-edit", {
        "edit-taskproject-task-time-mapping-formik-add-project-button-edit": projectError
      })
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics"
    }, editAddedShow ? "".concat(editAddedShow.projectName, " ").concat(editAddedShow.taskName ? " - ".concat(editAddedShow.taskName) : "") : "+ Select Project & Task"), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
      isNavClick: isNavClick,
      setNavClick: setNavClick,
      editAddedShow: editAddedShow,
      setEditAddedShow: setEditAddedShow,
      projectListing: projectListing,
      setProjectError: setProjectError,
      from: props.from ? "desktop" : null,
      setFieldValue: setFieldValue,
      type: "editTask",
      addedShow: null,
      setAddedShow: null
    })))))), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-edit-time-div"
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "taskDescription"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, {
        className: ""
      }, /*#__PURE__*/React.createElement(Form.Label, {
        className: "task-tracker-edit-label"
      }, "Description"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Field, _extends({
        as: Form.Control,
        name: "taskDescription",
        type: "text",
        placeholder: "Type the description"
      }, field)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-edit-task-date project-task-time-mapping-edit-time-div"
    }, /*#__PURE__*/React.createElement("label", {
      className: "task-tracker-edit-label"
    }, "Date"), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-calender-div manual-page-content-wrapper-filter-date-date-section"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      trigger: "click",
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Popover, {
        className: "project-task-time-mapping-wrapper-menu-filter-overlay-trigger"
      }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(DatePicker, {
        selected: editManualStartDate,
        onChange: handleChange,
        open: isEditManualDatePickerOpen,
        inline: true,
        maxDate: new Date()
      })))
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-calender-icon-div"
    }, /*#__PURE__*/React.createElement(GoCalendar, {
      className: "project-task-time-mapping-section-calender-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "project-task-time-mapping-section-calender-text"
    }, arrayToStringOutput([editManualStartDate, editManualStartDate], organisationSettings.organisationTimezone)))))), /*#__PURE__*/React.createElement("div", {
      className: "project-task-time-mapping-edit-time project-task-time-mapping-edit-time-div"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "editStartTime",
      required: true
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-task-time-mapping-formik-add-form-edit edit-task-project-task-time-mapping-formik-add-form"
      }, /*#__PURE__*/React.createElement(Form.Label, {
        className: "task-tracker-edit-label"
      }, "Task Start Time"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "editStartTime",
        value: values === null || values === void 0 ? void 0 : values.editStartTime,
        className: "project-task-time-mapping-formik-add-form-edit edit-task-project-task-time-mapping-formik-add-form-start-time ".concat(!(values !== null && values !== void 0 && values.editStartTime) ? "desktop-home-project-formik-edit-end-time" : ""),
        onChange: function onChange(e) {
          setFieldValue("editStartTime", e);
          startOnChange(e, setFieldValue);
        },
        placeholder: "Start Time",
        format: formats,
        use12Hours: true
        // inputReadOnly
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "editEndTime",
      isInvalid: endTimeError != null,
      required: true
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-task-time-mapping-formik-add-form-edit edit-task-project-task-time-mapping-formik-add-form"
      }, /*#__PURE__*/React.createElement(Form.Label, {
        className: "task-tracker-edit-label"
      }, "Task End Time"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "editEndTime",
        value: values === null || values === void 0 ? void 0 : values.editEndTime,
        className: "project-task-time-mapping-formik-add-form-edit project-task-time-mapping-formik-add-form-width edit-task-project-task-time-mapping-formik-add-form-end-time",
        onChange: function onChange(e) {
          setFieldValue("editEndTime", e);
          endOnChange(e, setFieldValue);
        },
        placeholder: "End Time",
        format: formats,
        use12Hours: true
        // inputIcon={undefined}
        // clearIcon={undefined}
        // inputReadOnly
        // disabledHours={disabledHours}
        // disabledMinutes={disabledMinutes}
      })), /*#__PURE__*/React.createElement("div", {
        className: "manual-home-project-formik-add-form-edit-end-time"
      }, editValueEndTime < editValueStartTime ? "End time should be greater than the start time" : ""));
    })))), /*#__PURE__*/React.createElement(Row, {
      className: "mt-4 mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "justify-content-md-center project-task-time-mapping-modal-edit-save-button-div"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      className: "project-task-time-mapping-modal-edit-save-button",
      type: "submit",
      disabled: editValueEndTime < editValueStartTime || editProjectTaskLoading
    }, editProjectTaskLoading ? "Loading..." : "Save Changes"))));
  })));
};
export var DeleteTaskModal = function DeleteTaskModal(props) {
  var showDeleteModal = props.showDeleteModal,
    handleDeleteClose = props.handleDeleteClose,
    organisationId = props.organisationId,
    taskRefetch = props.taskRefetch,
    setIsAllLoaded = props.setIsAllLoaded,
    projectIds = props.projectIds,
    taskIds = props.taskIds,
    userId = props.userId,
    teamId = props.teamId,
    planName = props.planName,
    last14Days = props.last14Days,
    role = props.role;
  if (showDeleteModal === null) {
    return null;
  }
  var _useMutation9 = useMutation(DELETE_TASK_TRACKER_MUTATION),
    _useMutation10 = _slicedToArray(_useMutation9, 2),
    deleteTaskTracker = _useMutation10[0],
    deleteTaskTrackerLoading = _useMutation10[1].loading;
  var handleDeleteTask = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!deleteTaskTrackerLoading) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            _context5.next = 4;
            return deleteTaskTracker({
              variables: {
                organisationId: organisationId,
                taskTimeId: showDeleteModal.taskTimeId,
                projectId: showDeleteModal.projectId,
                taskId: showDeleteModal.taskId,
                taskDate: moment(showDeleteModal.taskDate),
                totalTimeInSec: Number(showDeleteModal.totalTimeInSec)
              },
              // awaitRefetchQueries: true,
              // refetchQueries: [
              //   {
              //     query: GET_TASK_TRACKER_QUERY,
              //     variables: {
              //       organisationId,
              //       teamId,
              //       userId: [userId],
              //       projectId: projectIds.length ? projectIds : null,
              //       taskId: taskIds.length ? taskIds : null,
              //       limit: LIMIT,
              //       offset: 0,
              //       freePlanStartDate: planName == "free" ? (last14Days ? last14Days[0] : null) : null,
              //       freePlanEndDate: planName == "free" ? (last14Days ? last14Days[1] : null) : null,
              //       role,
              //       entryStatus : "",
              //     },
              //   },
              // ],
              //         update(cache, { data }) {
              //        if (!data?.deleteTaskTracker) return;
              //      cache.modify({
              //         fields: {
              //           getTaskTrackerDetails(existingData = {}, { readField }) {
              //             if (!existingData?.taskTrackerDatas) return existingData;
              //             const deletedTaskTimeId = showDeleteModal?.taskTimeId;
              //             const updatedList = existingData.taskTrackerDatas.filter(
              //               (itemRef) =>
              //                 readField("taskTimeId", itemRef) !== deletedTaskTimeId
              //             );
              //             return {
              //               ...existingData,
              //               taskTrackerDatas: updatedList,
              //               totalCount:
              //                 typeof existingData.totalCount === "number"
              //                   ? existingData.totalCount - 1
              //                   : existingData.totalCount,
              //             };
              //           },
              //         },
              //       });
              // }
              update: function update(cache, _ref19) {
                var data = _ref19.data;
                if (!(data !== null && data !== void 0 && data.deleteTaskTracker)) return;
                var deletedTaskTimeId = showDeleteModal === null || showDeleteModal === void 0 ? void 0 : showDeleteModal.taskTimeId;
                cache.modify({
                  fields: {
                    getTaskTrackerDetails: function getTaskTrackerDetails() {
                      var existingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      var _ref20 = arguments.length > 1 ? arguments[1] : undefined,
                        readField = _ref20.readField;
                      if (!(existingData !== null && existingData !== void 0 && existingData.taskTrackerDatas)) return existingData;
                      var updatedList = existingData.taskTrackerDatas.map(function (taskRef) {
                        var id = readField("taskTimeId", taskRef);

                        // 🎯 only update the deleted row
                        if (id !== showDeleteModal.taskTimeId) return taskRef;

                        // ✅ return updated reference (DO NOT remove)
                        return _objectSpread(_objectSpread({}, taskRef), {}, {
                          deletedStatus: "DELETED" // 👈 mark deleted
                        });
                      });
                      return _objectSpread(_objectSpread({}, existingData), {}, {
                        taskTrackerDatas: updatedList
                      });
                    }
                  }
                });
              }
            });
          case 4:
            response = _context5.sent;
            if (!(!response || !response.data || response.data.deleteTaskTracker === null)) {
              _context5.next = 9;
              break;
            }
            throw new Error("error");
          case 9:
            //taskRefetch?.();
            setIsAllLoaded(false);
            offsets = 0;
            handleDeleteClose();
            toast.success("Task deleted successfully!");
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  }, [deleteTaskTracker, deleteTaskTrackerLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteModal,
    onHide: handleDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Task")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Do you want to delete this work entry? "), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteTask("inactive")
  }, deleteTaskTrackerLoading ? "Loading..." : "Delete")));
};
export default AddTask;